import React, {useContext, useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {Divider, Menu, MenuItem} from '@mui/material';
import AuthContext from '../../contexts/authContext';
import useDarkMode from '../../hooks/useDarkMode';
import jwtInstance from '../../guards/jwt.interceptor';
import {API_USER} from '../../utils/restApi';
import {ICProfileInfo} from '../../utils/interfaces/ICProfileInfo';
import {getNameOfRoleInRo} from '../../utils/displayRole';
import {administrationAccount} from '../../menu';
import {Avatar, IconChevron} from '../../components/dashboard/transfer-market/tmShared';
import '../../components/dashboard/transfer-market/transfer-market.css';

// Contul din header (designul Transfer market 2.0): avatar + nume + rol, meniu cu cont, tema si iesire.
// compact=true (header-ul de mobil) arata doar avatarul.
const HeaderUserMenu = ({compact = false}: {compact?: boolean}) => {
    const navigate = useNavigate();
    const {logout} = useContext(AuthContext);
    const {darkModeStatus, setDarkModeStatus} = useDarkMode();
    const [anchor, setAnchor] = useState<HTMLElement | null>(null);
    const [profile, setProfile] = useState<ICProfileInfo>();
    const user = JSON.parse(`${localStorage.getItem('user')}`);

    useEffect(() => {
        if (!user?.uuid) return;
        jwtInstance.get(API_USER.contactInfo, {params: {uuid: user.uuid}})
            .then(response => setProfile(response.data))
            .catch(() => {});
    }, [user?.uuid]);

    const name = profile?.fullName || user?.email || 'Contul meu';
    const role = profile?.nameOfRole ? getNameOfRoleInRo(profile.nameOfRole) : '';
    const close = () => setAnchor(null);

    return (
        <>
            <button type='button' className={`vtm-hdr-user${compact ? ' vtm-hdr-user--compact' : ''}`}
                    aria-haspopup='menu' aria-expanded={Boolean(anchor)} aria-label={compact ? `Contul meu: ${name}` : undefined}
                    onClick={(e) => setAnchor(e.currentTarget)}>
                <Avatar name={name} seed={user?.uuid} photo={profile?.profileImage || undefined} size='40'/>
                {!compact && (
                    <>
                        <span className='vtm-hdr-user-id'>
                            <span className='vtm-hdr-user-name'>{name}</span>
                            {role && <span className='vtm-hdr-user-role'>{role}</span>}
                        </span>
                        <IconChevron/>
                    </>
                )}
            </button>
            <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={close} className='vtm-menu vtm-hdr-menu'
                  anchorOrigin={{vertical: 'bottom', horizontal: 'right'}} transformOrigin={{vertical: 'top', horizontal: 'right'}}>
                <div className='vtm-hdr-menu-head'>
                    <div className='vtm-hdr-user-name'>{name}</div>
                    <div className='vtm-meta'>{[role, profile?.email || user?.email].filter(Boolean).join(' · ')}</div>
                </div>
                <Divider/>
                <MenuItem onClick={() => { close(); navigate(administrationAccount.account.path); }}>Contul tău</MenuItem>
                <MenuItem onClick={() => { close(); setDarkModeStatus(!darkModeStatus); }}>
                    {darkModeStatus ? 'Treci pe modul luminat' : 'Treci pe modul întunecat'}
                </MenuItem>
                <Divider/>
                <MenuItem className='vtm-hdr-menu-out' onClick={() => { close(); logout(); }}>Ieșire din aplicație</MenuItem>
            </Menu>
        </>
    );
};

export default HeaderUserMenu;
